const sortAlphabetical = (arr, isReversed) => {
  const plusOne = !isReversed ? 1 : -1
  const minusOne = !isReversed ? -1 : 1
  return [
    ...arr.sort((a, b) => {
      const checkName = a?.name.toUpperCase() < b?.name.toUpperCase()
      return checkName ? minusOne : plusOne
    })
  ]
}

export default sortAlphabetical
